import React, { useEffect, useState } from "react";
import { Card, Col, Modal, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import axios from "axios";
import Baseurl from "../../../Baseurl";
function ViewOwner(props) {
  const [riderListData, setRiderListData] = useState([]);

  const [viewimage, setViewImage] = useState();

  const [show1, setShow1] = useState(false);
  const [ownerDetails, setOwnerDetails] = useState([]);

  const [spinnerAccept, setSpinnerAccept] = useState(false);
  const { id, val } = props.match.params;
  var history = useHistory();
  const handleClose1 = () => {
    setShow1(false);
  };

  function getData() {
    let listData = [];

    axios
      .get(Baseurl.baseurl4 + `/go-food-owner/get-rowner-detals-by-id/${id}`)
      .then((res) => {
        console.log("rider details", res.data.rOwnerDetails);
        if (res.data.message == "No Rider Found") {
        } else {
          if (res.data.rOwnerDetails) {
            setOwnerDetails(res.data.rOwnerDetails);
            listData = [
              {
                title: "Name",
                data: res.data.rOwnerDetails.ROwnerName,
              },

              {
                title: "Email",
                data: res.data.rOwnerDetails.ROwnerEmail,
              },
              {
                title: "Contact No",
                data: res.data.rOwnerDetails.ROwnerPhoneNumber,
              },
              {
                title: "Onboarding Code",
                data: res.data.rOwnerDetails.ROwnerOnboardingCode,
              },
              {
                title: "Adharcard Number",
                data: res.data.rOwnerDetails.ROwnerAadhaarNumber,
              },
            ];
            console.log("list data", listData);
            setRiderListData(listData);
          }
        }
      })
      .catch((err) => {});
  }
  useEffect(() => {
    getData();
  }, []);

  const accept = () => {
    const params = { ownerID: id };
    axios
      .put(`${Baseurl.baseurl4}/go-food-super-admin/verify-owner-food`, params)
      .then((res) => {
        if (res.data.status) {
          swal("Accepted", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setSpinnerAccept(false);
          history.push("/Restaurant-Owners");
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }

        handleClose1();
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  };
  function viewImage(img) {
    setShow1(true);
    setViewImage(img);
  }

  return (
    <Col xl="12">
      <Modal size="lg" show={show1} onHide={handleClose1}>
        <Modal.Body>
          <div>
            <img
              alt=""
              style={{
                resizeMode: "cover",
                width: "100%",
                height: "100%",
              }}
              className="playerProfilePic_home_tile"
              src={viewimage}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <Card.Title className="text-white">Rider Details</Card.Title>
          <button
            className="btn btn-primary"
            onClick={() => {
              history.goBack();
            }}
          >
            Back
          </button>
        </Card.Header>
        <Card.Body>
          <Card.Text>
            <div className="profile-personal-info ">
              {riderListData &&
                riderListData.map((val) => {
                  return (
                    <>
                      {val.data && (
                        <div className="row mb-2 ">
                          <div className="col-3 mt-1">
                            <h5 className="f-w-500 text-white ">
                              {val.title}
                              <span className="pull-right">:</span>
                            </h5>
                          </div>
                          <div className="col-9">
                            <span>{val.data} </span>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              <div className="row mb-2 mt-3">
                <div className="col-3 mt-5">
                  <h5 className="f-w-500 text-white">
                    Adhar Images
                    <span className="pull-right">:</span>
                  </h5>
                </div>
                <div className="col-sm-9">
                  <div className="row">
                    {ownerDetails.ROwnerAadhaarImages &&
                      ownerDetails.ROwnerAadhaarImages.map((payload, index) => {
                        return (
                          <div
                            onClick={() => {
                              viewImage(payload);
                            }}
                            className="col-sm-4"
                            style={{
                              marginTop: "5px",
                              width: 180,
                              height: 100,
                              aspectRatio: 1 * 1.4,
                            }}
                          >
                            <img
                              alt=""
                              src={payload}
                              style={{
                                resizeMode: "cover",
                                width: "100%",
                                height: "100%",
                              }}
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-3 mt-5">
                  <h5 className="f-w-500 text-white">
                    Pan Image
                    <span className="pull-right">:</span>
                  </h5>
                </div>
                <div className="col-sm-9">
                  <div className="row">
                    <div
                      onClick={() => {
                        viewImage(ownerDetails.ROwnerPanImage);
                      }}
                      className="col-sm-4"
                      style={{
                        marginTop: "5px",
                        width: 180,
                        height: 100,
                        aspectRatio: 1 * 1.4,
                      }}
                    >
                      <img
                        alt=""
                        src={ownerDetails.ROwnerPanImage}
                        style={{
                          resizeMode: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card.Text>
        </Card.Body>
        {!ownerDetails.ROwnerVerified && !ownerDetails.ROwnerBlock && (
          <Card.Footer className=" d-sm-flex justify-content-between align-items-center">
            {spinnerAccept ? (
              <div className="ml-auto mr-2">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <button
                className="btn btn-primary ml-auto mr-2"
                onClick={(e) => {
                  setSpinnerAccept(true);
                  accept(e);
                }}
              >
                Accept
              </button>
            )}
          </Card.Footer>
        )}
      </Card>
    </Col>
  );
}

export default ViewOwner;
